import { makeStyles } from "@material-ui/core/styles";
import React, { FC } from "react";

const BackLinkButton: FC<{
  onClick: () => void;
}> = ({ onClick }) => {
  const classes = useStyles();
  return (
    <div className={classes.area} onClick={onClick}>
      <p className={classes.text}>応援一覧に戻る</p>
    </div>
  );
};
export default BackLinkButton;

const useStyles = makeStyles((theme) => ({
  area: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "0",
      marginBottom: "13px",
      "&:before": {
        content: "''",
        display: "inline-block",
        width: "19px",
        height: "13px",
        backgroundImage: "url(../img/return_back.png)",
        backgroundSize: "cover",
      },
    },
  },
  text: {
    fontSize: "12px",
    position: "relative",
    top: "-2px",
    display: "inline-block",
    width: "auto",
    transformOrigin: "top left",
    marginLeft: "9px",
  },
}));
